import { InfoOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import { useAtom } from "jotai";
import { ReactElement, useEffect } from "react";
import { failedNotificationTypeAtom } from "atoms";
import { useTranslation } from "react-i18next";
import Alert from "shared/components/Alert";

export default function ErrorNotification(): ReactElement {
  const [notificationType, setNotificationType] = useAtom(
    failedNotificationTypeAtom
  );
  const { t } = useTranslation();

  useEffect(() => {
    if (notificationType !== "none") {
      setTimeout(() => {
        setNotificationType("none");
      }, 3000);
    }
  }, [notificationType, setNotificationType]);

  const handleClose = () => {
    setNotificationType("none");
  };
  const message = t(`errorMessages.${notificationType}Failed`);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={notificationType !== "none"}
      message={message}
      id={`notification-${notificationType}-failed`}
    >
      {notificationType !== "none" ? (
        <Alert
          sx={{ backgroundColor: "error.main", color: "white" }}
          onClick={handleClose}
          severity="error"
          icon={false}
        >
          <Stack direction="row" gap={1} alignItems="center">
            <InfoOutlined sx={{ color: "white" }} />
            <Typography variant="body2">{message}</Typography>
          </Stack>
        </Alert>
      ) : (
        <span />
      )}
    </Snackbar>
  );
}
